<template>
  <q-row>
    <router-link to="/login">
      <span>Log In</span>
      <br />
    </router-link>
    <router-link to="/logout">
      <span>Log Out</span>
      <br />
    </router-link>

    <router-link :to="{ name: 'list', params: { structureKey: 'parameter' } }">
      <span>List</span>
      <br />
    </router-link>
    <router-link
      :to="{
        name: 'detail',
        params: {
          structureKey: 'parameterDetail',
          modelId: '5efb18dd9c26eb0924c217a9',
        },
      }"
    >
      <span>Detail</span>
      <br />
    </router-link>
    <router-link :to="{ name: 'map', params: { structureKey: '123' } }">
      <span>MAP</span>
      <br />
    </router-link>
    <router-link :to="{ name: 'bpmn', params: { processId: '123' } }">
      <span>BPMN</span>
      <br />
    </router-link>
  </q-row>
</template>

<script>
export default {
  name: "DashboardIndex",

  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped></style>
